export const RECEIVE_THEME = "RECEIVE_THEME";